/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Sync_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't sync to VEKN." |
*
* @param {Vekn_Sync_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sync_error = /** @type {((inputs?: Vekn_Sync_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sync_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la synchronisation avec la VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo sincronizar con la VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível sincronizar com a VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione con la VEKN non riuscita.")
	return /** @type {LocalizedString} */ ("Couldn't sync to VEKN.")
});